import {useState, useEffect} from "react";
import {Box, Input, InputGroup, useMediaQuery} from "@chakra-ui/react";
import {BiSearch} from "@onemind-services-llc/react-icons-ng/bi";
import StripedTable from "./StripedTable";
import CardList from "./cardList";
import {useCalculator} from "../context/calculatorContext/context";

const TableComponent = (props) => {
  const {vendor} = props;
  const {entireData} = useCalculator();
  const [searchKey, setSearchKey] = useState("");
  const [filteredData, setFilteredData] = useState(entireData);
  const [isMobile] = useMediaQuery(["(max-width: 600px)"]);

  useEffect(() => {
    if (vendor !== "all-vendor")
      setFilteredData(entireData.filter((item) => item.vendor === vendor));
    else setFilteredData(entireData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vendor !== "all-vendor")
      setFilteredData(entireData.filter((item) => item.vendor === vendor));
    else setFilteredData(entireData);
  }, [vendor, entireData]);

  useEffect(() => {
    let newData = [];
    if (vendor !== "all-vendor")
      newData = entireData.filter((item) => item.vendor === vendor);
    else newData = entireData;

    if (searchKey) {
      newData = newData?.filter(
        (row) => row["name"]?.toLowerCase().indexOf(searchKey) > -1
      );
    }
    setFilteredData(newData);
  }, [searchKey, entireData, vendor]);

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent={"flex-end"}>
        <InputGroup startElement={<BiSearch color="gray.300" />} w="250px">
          <Input
            type="search"
            placeholder="Filter Name..."
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            background={"#f9fafb"}
            color={"#111827"}
            border={"1px solid #d1d5d8"}
            data-cy="table-search-input"
          />
        </InputGroup>
      </Box>
      <Box mt="10px">
        {isMobile ? (
          <CardList data={filteredData} />
        ) : (
          <StripedTable data={filteredData} />
        )}
      </Box>
    </>
  );
};

export default TableComponent;
